/**
 * This is the twofaOtpController.
 * @memberOf twofa Module
 * @namespace twofaOtpController
 */

/**
 * @name twofaOtpController
 * @desc Create the controller.
 * @param $scope
 * @param coreService
 * @param $state
 * @memberOf twofa Module.twofa Controller
 * @ngInject
 */ 
function twofaOtpController($scope, $translate, coreService, $log, $http, $window) { 
  // Assign this controller as the view-model.
  var vm = this;
  
  //methods
  vm.shouldDisableSubmit = shouldDisableSubmit;
  vm.passCode = '';
  vm.has_errors = false;
  vm.errorMessage= '';
  vm.twoFactorAuthenticationType = '';
  vm.productAppDisplayName = '';
  vm.isRememberMeOn = false;
  vm.rememberMe = false;
  vm.passcodeOnBlur = passcodeOnBlur;
  // Activate the controller.
  activate();

  // Activates the controller.
  function activate() {
    // Read Identity Server's data model
    var model = coreService.getIdentityModel();
     $scope.model = model;
     vm.has_errors= model.has_errors;
     vm.errorMessage= model.errorMessage;
     vm.twoFactorAuthenticationType = model.two_factor_auth_type;

     if($scope.model.data != null){       
      if($scope.model.data.productAppDisplayName != null && typeof($scope.model.data.productAppDisplayName) !== 'undefined'){
        vm.productAppDisplayName = $scope.model.data.productAppDisplayName;
      }

      if($scope.model.data.isRememberMeOn !== null && typeof($scope.model.data.isRememberMeOn) !== 'undefined'){
        vm.isRememberMeOn = $scope.model.data.isRememberMeOn;
      }
    }
    
    //Setup translation
    
	let stateCheck = setInterval(() => {
      if ($window.document.readyState === 'complete') {
        clearInterval(stateCheck);
        vm.isPageLoadComplete = true;
        
        $translate(['twofa.otp.form.header', 'twofa.otp.form.code_input', 'twofa.otp.form.code_input_fraedom_app',
                    'twofa.otp.form.passcode', 'twofa.otp.form.done', 'twofa.otp.form.rememberme']) 
        .then(function(data) {
            vm.data = data;
            if(vm.has_errors)
            {
              setAriaLabelOnLoad(false, 'passCode');
            }
            else
            {
              setAriaLabelOnLoad(true, 'passCode');
            }            
            setFocus("passCode");   
        });
        
      }
    }, 0);
    
  }

  function shouldDisableSubmit(){
    return vm.passCode === '';
  }

  function passcodeOnBlur(e){    
    setAriaLabelOnLoad(false, 'passCode')
  }

  function setFocus(id)
  {
    var element = $window.document.getElementById(id);
    if(typeof(element) != 'undefined' && element != null)
    {
      $window.setTimeout(function(){ element.focus(); }, 0);
    }      
  }

  function setAriaLabelOnLoad(enable, id)
  {
    var element = document.getElementById(id);
    if(typeof(element) != 'undefined' && element != null)
    {
      var arialDescriptionText = vm.data['twofa.otp.form.passcode'];
      if (enable)
      {
        arialDescriptionText = vm.data['twofa.otp.form.header'] + '. ' + vm.data['twofa.otp.form.code_input'];       
      }

      element.setAttribute('aria-label', arialDescriptionText);
    }
  }
 
}

export default twofaOtpController;



// WEBPACK FOOTER //
// ./src/login/2fa/otp/2fa.otp.controller.js